export default __webpack_public_path__ + "static/media/body.657cfbe3.png";